import { useState } from 'react';
import styled from 'styled-components';
import { ShareDropdown } from '@elfsight/widget-modal';
import type { CTAButton } from '../../common';
import { CommonButton } from './common-button';

export const ButtonWithShare = ({
  ctaButton,
  isFullWidth
}: {
  ctaButton: CTAButton;
  isFullWidth: boolean;
}) => {
  const [opened, setOpened] = useState(false);
  const [anchorElement, setAnchorElement] = useState<Element | null>(null);
  const clickHandler = () => setOpened(true);

  return (
    <>
      <CommonButton
        ref={setAnchorElement}
        ctaButton={ctaButton}
        onClick={clickHandler}
        fullWidth={isFullWidth}
      />
      <StyledShareDropdown
        link={window.location.href}
        anchorElement={anchorElement}
        open={opened}
        onCloseRequest={() => {
          setOpened(false);
        }}
      />
    </>
  );
};

const StyledShareDropdown = styled(ShareDropdown)<{
  _font?: string;
}>`
  ${({ _font }) => !!_font && `font-family: ${_font}`};
`;
